export default "__VITE_ASSET__DrfEdh26__"